<template>
	<div :class="`fps-bar-container fps-bar-container--${color}`">
		<div class="fps-bar-content">
			<div class="fps-bar">
				<div
					class="fps-bar__percentage"
					:class="{'fps-bar__percentage--pending' : !fps}"
					:style="{ width: `${fpsPercentage}%` }"
				/>
			</div>

			<i v-if="fps" class="fps-bar__number">{{ fps }} <span>FPS</span> </i>
			<i v-else class="fps-bar__pending">FPS pending</i>
		</div>
	</div>
</template>

<script>

export default {
	name: "FpsBar",
	props: {
		fps: {
			type: [String, Number],
			default: () => 0
		}
	},
	computed: {
		color() {
			return this.fps >= 60 ? "green" : "yellow";
		},
		fpsPercentage() {
			return (this.fps / 300) * 100;
		}
	}
};
</script>

<style lang="scss" scoped>
.fps-bar {
	height: 5px;
	width: 100%;
	border-radius: 2px;
	background-color: #ECEEEF;

	&__percentage {
		height: 100%;
		border-radius: 2px;
		transition: all 0.3s;
	}

	&__percentage--pending {
		width: 50% !important;
		background-color: #C5CBCF !important;
	}

	&__number {
		font-size: 13px;
		font-weight: bold;
		display: block;
		margin: 3px 0;

		span {
			text-transform: uppercase;
			font-size: 9px;
		}
	}

	&__pending {
		color: #5F707F;
		font-size: 14px;
		font-weight: bold;
		letter-spacing: 0;
		display: inline-block;
		margin: 2px 0;
	}
}

.fps-bar-container--green {
	.fps-bar__percentage {
		background-color: #1ab863;
	}

	.fps-bar__number {
		color: #1ab863;
	}
}

.fps-bar-container--yellow {
	.fps-bar__percentage {
		background-color: #c77f09;
	}

	.fps-bar__number {
		color: #c77f09;
	}
}

.fps-bar-container--red {
	.fps-bar__percentage {
		background-color: #a53e4b;
	}

	.fps-bar__number {
		color: #a53e4b;
	}
}
</style>
